import React, { FunctionComponent } from 'react';
import { Prefecture } from '../../../types/personShow';

type Props = {
  location: string;
  suggestPrefectures: Prefecture[];
  prefectures: Prefecture[];
  handleChange: (value: string) => void;
 };

export const Presentation: FunctionComponent<Props> = ({
  location,
  suggestPrefectures,
  prefectures,
  handleChange,
}) => {
  return (
    <div className="person__show__modal__inner">
      <p className="person__show__modal__inner--title">お住まいの都道府県を選択して保存してください</p>
      <div className="person__show__modal__inner__location__wrapper">
        <ul className="person__show__modal__inner__location">
          {suggestPrefectures.map((suggestPrefecture) => (
            <li
              key={`suggestion_${suggestPrefecture.name}`}
              className={suggestPrefecture.name === location ? 'selected' : ''}
              onClick={() => handleChange(suggestPrefecture.name)}
            >
              {suggestPrefecture.name}
            </li>
          ))}
        </ul>
      </div>
      <ul className="person__show__modal__inner__locationList">
        {prefectures.map((prefecture) => (
          <li
            id={`person_show_modal_location_${prefecture.id}`}
            key={`location_${prefecture.name}`}
            className={prefecture.name === location ? 'selected' : ''}
            onClick={() => handleChange(prefecture.name)}
          >
            {prefecture.name}
            {prefecture.name === location && (
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10" fill="none">
                <path d="M4.88542 9.89714L0.21875 5.23047L1.11458 4.33464L4.88542 8.10547L12.8854 0.105469L13.7812 1.0013L4.88542 9.89714Z" fill="#19190F"/>
              </svg>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
